<template>
  <div class="categories-container">
    <cube-scroll-nav v-if="categories.length" :side="true" :options="options" :data="categories" :current="current">
      <cube-scroll-nav-panel v-for="item in categories" :key="'cat-' + item.id" :label="'cat-' + item.id"
        :title="item.title">
        <div class="dishes-wrapper" style="padding:10px;">
          <div class="dish-box" v-for="(dish, index) in item.dishes" :key="index">
            <div @click="detail(dish)" class="dish-thumb">
              <img :src="dish.img">
            </div>
            <div class="dish-item-info">
              <div class="dish-name">{{ dish.name }}</div>
              <div class="dish-item-footer">
                <div class="dish-item-price">€{{ dish.price }}</div>
                <div class="dish-item-add">
                  <van-icon @click="dish.is_menu== 2 ? addToCart(dish) : detail(dish)" size="26" color="red" name="add" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </cube-scroll-nav-panel>
    </cube-scroll-nav>
    <div v-if="!$store.state.showCart" class="cart-bar">
      <div class="cart-wrapper">
        <div class="cart-bar-icon">
          <van-icon color="#ffffff" size="65" name="cart-circle" />
          <van-badge :content="$store.getters.totalDishes" />
          <span class="cart-bar-subtotal">€{{ (parseFloat($store.getters.subTotalAmount) + parseFloat($store.getters.totalPriceMenuFixed)).toFixed(2) }}</span>
        </div>
        <div>
          <van-button @click="showCartPopup()" type="primary">CARRELLO</van-button>
        </div>
      </div>
    </div>

    <van-popup round closeable close-icon-position="top-left"
      :style="{ width: '420px', maxWidth: '100%', height: '680px', maxHeight: '100%' }" v-model="showDetail">
      <div class="dish-detail-img">
        <img :src="dish.img">
        <div class="dish-detail-code">{{ dish.code }}</div>
      </div>
      <div class="dish-detail-content">
        <h3 class="dish-detail-name">{{ dish.name }}</h3>
        <div v-if="dish.is_conge == 1 || dish.is_spicy == 1 || dish.is_vegan == 1" class="dish-other">

          <span v-if="dish.is_conge == 1" class="conge pdlr-5"><img src="@/assets/icon/dish/congelato.png"><span
              class="congel">congelato</span></span>

          <span v-if="dish.is_spicy == 1" class="conge pdlr-5"><img src="@/assets/icon/dish/peperoncino.png"><span
              class="congel">piccante</span></span>

          <span v-if="dish.is_vegan == 1" class="conge pdlr-5"><img src="@/assets/icon/dish/vegetariano.png"><span
              class="congel">vegetariano</span></span>

        </div>
        <div class="dish-detail-description">
          <van-divider>Descrizione</van-divider>
          <p>{{ dish.description }}</p>
        </div>
        <div class="dish-detail-allergens">
          <van-divider>Allergeni</van-divider>
          <div class="dish-other">
            <span v-for="(allergen, index) in dish.allergens" :key="'a-' + index" class="conge pdlr-5"><img
                :src="allergen.img"><span class="allergens">{{ allergen.name }}</span></span>
          </div>

        </div>

        <div class="detail-add-to-cart">
          <cube-button icon="cubeic-add" @click="addToCart(dish)" :primary="true">Aggiungi al carrello</cube-button>
        </div>
      </div>
    </van-popup>

    <van-popup round closeable close-icon-position="top-left"
      :style="{ width: '420px', height: '680px', maxWidth: '100%', overflow: 'hidden' }" v-model="showMenuFixedDetail"
      v-if="showMenuFixedDetail">
      <div class="menu-fixed-container">
        <div>
          <img style="width:100%; height:220px;" :src="dish.img">
        </div>
        <div>
          <cube-checkbox-group v-model="menuFixedSelect" :max="dish.menu_fixed_limit">
            <cube-checkbox v-for="(menuDish, index) in dish.menu_fixed_dishess" :option="menuDish.id.toString()"
              :key="'m' + index">
              <div class="menu-dishes-item">
                <img class="thumb-menu-dish" :src="menuDish.img">
                <span>{{ menuDish.code }}. {{ menuDish.name }}</span>
              </div>
            </cube-checkbox>
          </cube-checkbox-group>
        </div>
        <div class="menu-fixed-footer">
          <div class="menu-fixed-footer-left">
            <span class="label-limit"> Piatti: {{ menuFixedSelect.length }}/{{ dish.menu_fixed_limit }}</span>
          </div>
          <div class="menu-fixed-footer-right">
            <cube-button @click="addToCart(dish)" :disabled="!(menuFixedSelect.length >= dish.menu_fixed_limit)"
              :primary="true">Aggiungi</cube-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Notify } from 'vant';
export default {
  name: 'Dishes',
  data: () => ({
    options: {
      mouseWheel: true
    },
    current: null,
    categories: [],
    showDetail: false,
    showMenuFixedDetail: false,
    menu_fixed_dishess: [],
    menu_fixed_dishes: [],
    menuFixedSelect: [],
    dish: {}
  }),
  created() {
    this.fetchData()
  },
  mounted() {
    this.getCartDishes()
  },
  methods: {
    fetchData() {
      this.axios.get('/api/dishes/index?mid=' + this.$route.params.mid + "&dishesType=delivery")
        .then((res) => {
          this.categories = res.data
        })
    },
    showCartPopup(){
      if (!localStorage.getItem(window.btoa('user'))) {
        this.$router.push('/' + this.$route.params.mid + '/login')
      }else{
        this.$store.state.showCart = true
      }
    },
    getCartDishes() {
      const username = window.atob(localStorage.getItem(window.btoa('user')))
      const user_mid = { user: username, mid: this.$route.params.mid }
      this.axios.get('/api/cart/cartList', { params: user_mid }).then((res) => {
        this.$store.state.cart = res.data.data
      })
    },
    detail(dish) {
      this.dish = dish
      console.log(this.dish)
      if (dish.is_menu == 2) {
        this.showDetail = true
      } else {
        this.dish.menu_fixed_dishess = []
        this.dish.menu_fixed_dishes.forEach(d => {
          this.categories.forEach(cat => {
            cat.dishes.forEach(disht => {
              if (d == disht.id) {
                this.dish.menu_fixed_dishess.push(disht)
              }
            })
          })
        })
        this.menuFixedSelect = []
        this.showMenuFixedDetail = true
      }
    },
    addToCart(item) {
      item['mid'] = this.$route.params.mid
      item['user'] = window.atob(localStorage.getItem(window.btoa('user')))

      
      if (item.is_menu == 1) {
        item['menu_fixed'] = []
        this.menuFixedSelect.forEach(id => {
          this.dish.menu_fixed_dishess.forEach(items => {
            if (id == items.id) {
              item['menu_fixed'].push({ id: items.code, name: items.name })
              this.showMenuFixedDetail = false
              return
            }
          })
        })
      }

      if (localStorage.getItem(window.btoa('user'))) {
        this.axios.post('/api/cart/add', item).then((res) => {
          if (res.data.code == 200) {
            Notify({ type: 'success', message: item['name'] + ' Aggiunto al carrello' })
            this.$store.state.cart = res.data.data
            return
          }
          Notify({ type: 'warning', message: 'Stato un errore' })

        })
      } else {
        this.$router.push('/' + this.$route.params.mid + '/login')
      }
    }
  }
}
</script>
<style>
.clearfix {
  clear: both;
}

.categories-container {
  height: calc(100% - (46px + 46px));
  overflow: hidden;
  background: #f7f7f7;
  position: relative;
}
.categories-container 
.cube-scroll-nav-bar-items,
.categories-container 
.cube-scroll-nav-panels {
  padding-bottom: 80px;
}

.cube-scroll-nav-bar-items {
  width: 160px;
  white-space: normal;
}

.cube-scroll-nav-bar-items .cube-scroll-nav-bar-item_active {
  background: #f7f7f7;
}

.cube-scroll-nav-bar-item {
  background: #ffffff;
  font-size: 16px;
}

.dishes-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between；
}

.dish-box {
  flex: 1;
  margin: 5px 10px 20px;
  border-radius: 10px;
  background: #ffffff;
  min-width: 236px;
  max-width: calc(100% / 3 - 20px);
}

.dish-thumb {
  height: 160px;
  border-radius: 5px;
}

.dish-thumb img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: fill;
}

.dish-item-info {
  width: 100%;
  padding: 5px;
}

.dish-name {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 400;
}

.dish-item-footer {
  display: flex;
  line-height: 26px;
}

.dish-item-price,
.dish-item-add {
  flex: 1;
  justify-content: flex-end;
  ;
  color: red;
}

.dish-item-add {
  text-align: right;
}

.cube-sticky-content {
  background: #ffffff;
  padding: 10px 5px;
}

.cart-bar {
  width: calc(100% - 120px);
  max-width: 1128px;
  height: 65px;
  background: red;
  position: absolute;
  z-index: 1;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50px;
  background: #3d3e40;
}

.cart-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}

.cart-bar-icon {
  flex: 1;
}

.cart-bar .van-button {
  height: 65px;
  width: 220px;
  border-bottom-right-radius: 50px;
  border-top-right-radius: 50px;
  font-size: 22px;
}

.cart-bar .van-badge {
  position: absolute;
  padding: 3px;
  font-size: 12px;
  left: 40px;
  top: 7px;
}

.cart-bar-subtotal {
  color: #ffffff;
}

@media screen and (max-width: 786px) {
  .cube-scroll-nav-bar-items {
    width: 100px;
  }

  .dishes-wrapper {
    display: block;
  }

  .dish-box {
    max-width: 100%;
    display: block;
    clear: both;
    margin: 0;
    margin-bottom: 10px;
    width: 100%;
    height: 90px;
    background: #ffffff;
    border-radius: 8px;
    float: unset;
  }

  .dish-thumb {
    width: 100px;
    height: 90px;
    float: left;
  }

  .dish-item-info {
    float: left;
    height: 100%;
    position: relative;
    width: calc(100% - 110px);
    padding: 5px;
    font-size: 16px;
  }

  .dish-item-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .cart-bar {
    bottom: 10px;
    width: calc(100% - 20px);
  }

  .cart-bar .van-button {
    width: 160px;
  }

}

.dish-detail-img {
  width: 100%;
  height: 220px;
  position: relative;
}

.dish-detail-img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.dish-detail-code {
  position: absolute;
  color: #ffffff;
  bottom: -33px;
  border: 2px solid #ffffff;
  left: 50%;
  font-size: 22px;
  background: #2827274d;
  padding: 20px;
  min-width: 20px;
  text-align: center;
  transform: translateX(-50%);
  border-radius: 50%;

}

.dish-detail-content {
  margin-top: 25px;
  padding: 10px;
}

.dish-detail-name {
  font-size: 26px;
  width: 100%;
  text-align: center;
}

.dish-detail-description {
  margin-top: 15px;
  text-align: center;
  min-height: 40px;
}

.dish-detail-allergens {
  margin-bottom: 50px;
}

.dish-other {
  text-align: center;
  height: 25px;
  margin-top: 10px;
  height: auto;
}

.conge {
  display: inline-block;
}

.dish-other .congel {
  display: inline-block;
}

.dish-detail-allergens {
  display: block;
}

.dish-other .allergens {
  display: inline-block;
  margin: 10px 2px;
}

.conge img {
  width: 25px;
  height: 25px;
  vertical-align: middle;

}

.pdlr-5 {
  padding: 0 5px;
}

.detail-add-to-cart {
  position: absolute;
  bottom: 5px;
  width: calc(100% - 20px);
}

.van-popup__close-icon {
  background-color: #1e1d1d57;
  border-radius: 50%;
  padding: 5px;
  color: #ffffff;
}

.menu-fixed-container {
  height: 100%;
  position: relative;
  padding-bottom: 50px;
  overflow-y: scroll;
}

.menu-fixed-footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #e1dcdc;
  z-index: 999;
  background: #ffffff;
}

.menu-fixed-footer-left {
  width: 60%;
  float: left;
  line-height: 50px;

}

.menu-fixed-footer-right {
  width: 40%;
  float: left;
}

.label-limit {
  margin-left: 10px;
}

.thumb-menu-dish {
  width: 40px;
  height: 40px;
}

.menu-dishes-item {
  height: 40px;
}

@media screen and (min-width: 787px) {
  .dish-box {
    max-width: calc(100% / 2 - 20px);
  }
}

@media screen and (min-width: 1120px) {
  .dish-box {
    max-width: calc(100% / 3 - 20px);
  }
}

@media screen and (min-width: 1228px) {
  .dish-box {
    max-width: calc(100% / 4 - 20px);
  }
}

@media screen and (min-width: 1485px) {
  .dish-box {
    max-width: calc(100% / 5 - 20px);
  }
}

@media screen and (min-width: 1740px) {
  .dish-box {
    max-width: calc(100% / 6 - 20px);
  }
}
</style>
